import { FunctionComponent } from 'react';

import { Stack } from '@mui/material';
import { IProgressSpinnerProps, ProgressSpinner } from './ProgressSpinner';
import { Card, CardContent, CardHeader } from './card';

interface ICenterProgressSpinnerProps extends IProgressSpinnerProps {
    padding?: number;
    addCardWrapper?: boolean;
    cardWrapperTitle?: React.ReactNode;
}
export const CenterProgressSpinner: FunctionComponent<ICenterProgressSpinnerProps> = (props: ICenterProgressSpinnerProps) => {

    const {
        padding = 5,
        addCardWrapper,
        cardWrapperTitle,
        ...progressSpinnerProps
    } = props;

    const spinnerBody = (
        <Stack justifyContent='center' alignItems='center' padding={padding}>
            <ProgressSpinner {...progressSpinnerProps} />
        </Stack>
    );

    if (addCardWrapper) {
        return (
            <Card>
                {cardWrapperTitle && <CardHeader title={cardWrapperTitle} />}
                <CardContent>
                    {spinnerBody}
                </CardContent>
            </Card>
        )
    }

    return spinnerBody;
};